import { createFileRoute } from "@tanstack/react-router";
import { ServicePage } from "@/components/sections/service-page";
import { pageData } from "@/lib/service-page-data";
const data = pageData["branding-creative-design"];
export const Route = createFileRoute("/marketing/branding-creative-design")({
  component: () => <ServicePage data={data} />,
  head: () => ({
    meta: [
      { title: `${data.title} — CoderLity` },
      { name: "description", content: data.sub },
      { property: "og:title", content: `${data.title} — CoderLity` },
      { property: "og:description", content: data.sub },
      { property: "og:url", content: "/marketing/branding-creative-design" },
    ],
    links: [{ rel: "canonical", href: "https://coderlity.com/marketing/branding-creative-design" }],
  }),
});
